export enum ExternalResourceStatusEnum {
    Pending = 1,
    Approved = 2,
    Denied = 3,
}
